import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AppState } from '../+store/app.states';
import { Observable, of } from 'rxjs';
import { catchError, tap, first, map } from 'rxjs/operators';
import { getIsAuth } from '../+store/auth/auth.selectors';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private store: Store<AppState>, public router: Router) { }

  canActivate(): Observable<any> {
    return this.store.pipe(
      select(getIsAuth),
      first(),
      map(isAuth => {
        if (isAuth) {
          return true;
        } else {
          this.router.navigate(['auth/login']);
        }
      }),
      catchError(error => {
        return of(false);
      })
    );
  }
}
